import { api } from '@/shared/api/api';
import { TourComponent } from '@/shared/components';
import Uploader from '@/shared/components/uploader/Uploader';
import { Skeleton } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTour } from '../../useTour';
import { availibleResultSelection } from './ChartConnent.constants';
import styles from './ChartContent.module.css';

const ChartContent = () => {
  const [actualVersions, setActualVersions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const { uploadFilesRef, steps } = useTour();

  const abortControllerRef = useRef(null);

  const fetchActualVersions = useCallback(async () => {
    try {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      const abortController = new AbortController();
      abortControllerRef.current = abortController;

      setLoading(true);
      api
        .get('api/app/getActualVersions', {
          signal: abortController.signal,
        })
        .then(({ data: resData }) => {
          const { eye, droneVision, eye4SDK, eye3, eyeLite, droneDetector, berry, sova } = resData;
          setActualVersions([eye, droneVision, eye4SDK, eye3, eyeLite, droneDetector, berry, sova]);
        })
        .finally(() => setLoading(false));
    } catch (err) {
      console.log('error in fetchActualVersions ', err);
    }
  }, []);

  useEffect(() => {
    fetchActualVersions();

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [fetchActualVersions]);

  return (
    <div className={styles.chartPageWrapper}>
      <TourComponent
        handleClose={() => setIsTourOpen(false)}
        handleOpen={() => setIsTourOpen(true)}
        isTourOpen={isTourOpen}
        steps={steps}
      />
      {availibleResultSelection.map((item, index) =>
        loading ? (
          <div className={styles.Uploader__container} key={item.index}>
            <Skeleton paragraph={{ rows: 2 }} active />
          </div>
        ) : (
          <div key={item.index}>
            <Uploader
              urlResult={item.urlResult}
              text={item.text}
              index={item.index}
              actualVersions={actualVersions}
              fetchActualVersions={fetchActualVersions}
              buttonRef={!index ? uploadFilesRef : null}
            />
          </div>
        )
      )}
    </div>
  );
};
export default ChartContent;
